import * as MaplibreGL from 'maplibre-gl';
// `?worker&url` makes Vite bundle the maplibre worker AND its sibling
// `maplibre-gl-shared.mjs` dependency into a single, self-contained file and
// hand us its URL, resolved correctly against the app bundle's location
// (CODE_HOME) even when hosted on a CDN.
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

/**
 * Sets the maplibre worker URL, which also selects the worker type:
 * JSSDK gets a classic worker, every other bundle gets a module worker.
 *
 * maplibre v6 is ESM-only and resolves its own worker URL from
 * `import.meta.url`, which breaks after bundling — hence setting it here. It
 * also picks the worker type from that URL alone:
 *   `url.endsWith('.cjs') ? classic : module`  (maplibre-gl/src/util/web_worker.ts)
 *
 * Keep `#.cjs` a URL *fragment*, never a real file extension. `aws s3 sync`
 * has no `Content-Type` mapping for `.cjs` and would serve the worker as
 * `binary/octet-stream`, which browsers reject.
 *
 * JSSDK must stay classic: it is embedded cross-origin in host pages whose
 * tooling may wrap `Worker` with an `importScripts()` shim, and
 * `importScripts` is forbidden in a module worker. Guarded by
 * `test/sdk/worker-type.spec.ts`. Nothing guards the other bundles.
 */

// Vite `define` substitutes this at build time, so there is no Node runtime
// here and no `@types/node` in this tsconfig.
declare const process: { env: Record<string, string | undefined> };

// Set only by deploy/vite.jssdk.config.js. Elsewhere Vite replaces
// `process.env` with an empty object, so this reads as false.
const useCjsWorker = process.env.MAPLIBRE_WORKER_CJS === 'true';

MaplibreGL.setWorkerUrl(useCjsWorker ? `${maplibreWorkerUrl}#.cjs` : maplibreWorkerUrl);
